module.exports = __webpack_public_path__ + "static/media/trash.3c9a15c0.svg";